import APIRequestService from './APIRequestService';

const request = new APIRequestService();

export const getReviewFunds = async ({ productId, queryParams, axiosCancelToken }) => {
  let url;
  if (productId === 0) {
    // when No product is selected
    url = `/universe-funds/fund-details-main?${queryParams}`;
  } else {
    // when product is selected
    url = `/universe-funds/fund-details-main/product/${productId}?${queryParams}`;
  }

  return request.get(url, {}, axiosCancelToken);
};

export const getFundDataPoints = async ({ fundId, axiosCancelToken }) => {
  const url = `/universe-funds/fund-details?ID=${fundId}`;
  return request.get(url, {}, axiosCancelToken);
};

export const addFundReview = async (payload) => {
  const url = '/universe-funds/add-fund-review';
  return request.post(url, { data: JSON.stringify(payload) });
};

export const getFundReviewNotesHistory = async (queryParams) => {
  const url = `/universe-funds/fund-details-history?${queryParams}`;
  return request.get(url);
};

export const getFundStatusByClient = async (queryParams) => {
  const url = `/universe-funds/fund-review-fundstatus-allproviders?${queryParams}`;
  return request.get(url);
};

export const getShareClassFunds = async (fiduciaryFundID) => {
  const url = `/universe-funds/fund-review-share-class?fiduciaryFundID=${fiduciaryFundID}`;
  return request.get(url);
};
